import { z } from "zod";

import { AuthenticationType } from "@/constants";

export const authenticationTypeSchema = z.enum(AuthenticationType);
